require('./okDiscountProductBox.scss');
require('./okDiscountProductBox.override.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classNames = require('classnames');
//@commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButtonCMS } = require('commonsComponents/OKButtonCMS');
// @components
const OkDiscountExternalCodeButton = require('components/okDiscount/okDiscountExternalCodeButton/okDiscountExternalCodeButton');
// @constants
const { DATE_FORMAT_WITH_DASHES } = require('constants/index');
const { URL_DISCOUNT } = require('constants/flagBasedFeatures');
// @utilities
const {
    PROC_DISCOUNTS,
    recordLink,
} = require('utilities/tagging');
// @helpers
const dateHelper = require('utilities/dateHelper');
const { getPersonTypeAndCodeSaltedHashed } = require('utilities/hash');

class OkDiscountProductBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saltedHashValue: ''
        }

        this.handleClickLegalSection = this.handleClickLegalSection.bind(this);
        this.handleClickCTA = this.handleClickCTA.bind(this);
        this.handleClickConditions = this.handleClickConditions.bind(this);
    }

    getPartnerId = () => {
        const { immOkDiscount, immGlobalVariables } = this.props;
        const immCallToAction = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'callToAction']);
        const callToActionUrl = immCallToAction && immCallToAction.get('url') || '';
        const partnerIds = immGlobalVariables.getIn(['variables', 'parameters', 'partner_id']).toJS();
        const partnerId = partnerIds.filter((partner) => callToActionUrl.toLowerCase().includes(partner.toLowerCase()))[0];
        return partnerId;
    }

    handleClickLegalSection() {
        const eventTag = this.props.immOkDiscount.getIn(['okDiscountDetail','discount', 'breadcrumbTitle']);
        recordLink(PROC_DISCOUNTS, 'ver condiciones', eventTag);
    }

    handleClickCTA(id) {
        const partnerId = this.getPartnerId();
        const urlDiscountsFlag = this.props.immFlagBasedFeatures.get(URL_DISCOUNT);
        const personTypeAndCodeSaltedHashed = getPersonTypeAndCodeSaltedHashed();
        this.setState({ saltedHashValue: personTypeAndCodeSaltedHashed });

        if (urlDiscountsFlag && partnerId) {
            const successCallback = () => this.navigateToNewLink();
            this.props.requestReferralPromotionDiscount(personTypeAndCodeSaltedHashed, partnerId, id, successCallback);
        }
        const eventTag = this.props.immOkDiscount.getIn(['okDiscountDetail','discount', 'breadcrumbTitle']);
        recordLink(PROC_DISCOUNTS, 'ir a promocion', eventTag);
    }

    handleClickConditions() {
        const eventTag = this.props.immOkDiscount.getIn(['okDiscountDetail','discount', 'breadcrumbTitle']);
        recordLink(PROC_DISCOUNTS, 'ver condiciones general', eventTag);
    }

    buildIcon(iconUrl) {
        const iconClassname = classNames('okdiscount-product-box__icon', {
            'okdiscount-product-box__icon--hidden': !iconUrl
        });

        return (
            <i
                className={iconClassname}
                style={{ backgroundImage: `url(${iconUrl})` }}
            />
        );
    }

    buildCallToAction(id) {
        const { immOkDiscount } = this.props;
        const isLoading = immOkDiscount.get('referralPromIsFetching') && immOkDiscount.getIn(["referralPromDiscountFetching", id, "isLoading"]);
        const immCallToAction = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'callToAction']);
        const urlDiscountsFlag = this.props.immFlagBasedFeatures.get(URL_DISCOUNT);
        const externalWebUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'externalWeb', 'url']);
        const externalWebText = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'externalWeb', 'text']);
        const externalWeb = !!externalWebUrl && !!externalWebText;
        const partnerId = this.getPartnerId();
        let buttonCMS;
        let externalWebButton;

        if (!!immCallToAction) {
            const callToActionUrl = immCallToAction.get('url') || '';
            const callToActionText = immCallToAction.get('text') || '';
            const iconIsEnabled = immCallToAction.get('iconIsEnabled');

            if (!!callToActionUrl && (!!callToActionText || iconIsEnabled)) {
                const navigationUrl = (!urlDiscountsFlag || !partnerId) && callToActionUrl;
                buttonCMS = (
                    <div className="okdiscount-product-box__external-buy-link">
                        <OKButtonCMS
                            color={immCallToAction.get('color')}
                            icon={immCallToAction.get('icon')}
                            iconAlignment={immCallToAction.get('iconAlignment')}
                            iconColor={immCallToAction.get('iconColor')}
                            iconGhost={immCallToAction.get('iconGhost')}
                            iconIsEnabled={iconIsEnabled}
                            inverseGhost={immCallToAction.get('inverseGhost')}
                            isOnlyIcon={immCallToAction.get('isOnlyIcon')}
                            onClick={() => this.handleClickCTA(id)}
                            openNewTab={immCallToAction.get('openNewTab')}
                            text={callToActionText}
                            isLoading={isLoading}
                            to={navigationUrl}
                        />
                    </div>
                );
            }
        }

        if (externalWeb) {
            externalWebButton = this.buildExternalWebButton();
        }

        return (
            <React.Fragment>
                {buttonCMS}
                {externalWebButton}
            </React.Fragment>
        );
    }

    buildExternalWebButton() {
        const { immOkDiscount } = this.props;
        const externalWebUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'externalWeb', 'url']);
        const externalWebText = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'externalWeb', 'text']);

        return (
            <div className="okdiscount-product-box__external-web-link">
                <OKLink
                    modifier="complementary"
                    target="_blank"
                    to={externalWebUrl}
                >
                    {externalWebText}
                </OKLink>
            </div>
        );

    }

    buildDiscountCodeItem() {
        const {
            immOkDiscount,
            requestExternalCode,
        } = this.props;
        const code = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'code', 'text']);
        const codeUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'code', 'url']);
        const hasExternalCode = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'hasExternalCode']);
        let hasDiscountClassButton = false;
        let discountCodeOrButton;
        let discountCodeItem;

        if (hasExternalCode) {
            hasDiscountClassButton = true;
            discountCodeOrButton = (
                <span className="okdiscount-product-box__list-item-value">
                    <OkDiscountExternalCodeButton
                        immOkDiscount={immOkDiscount}
                        requestExternalCode={requestExternalCode}
                    />
                </span>
            );
        } else if (!!code) {
            discountCodeOrButton = (
                <span className="okdiscount-product-box__list-item-value okdiscount-product-box__list-item-value--button">
                    {code.toUpperCase()}
                </span>
            );
        }

        if (!!codeUrl || !!discountCodeOrButton) {
            const codeIcon = this.buildIcon(codeUrl);
            const discountClassNames = classNames('okdiscount-product-box__list-item-container', {
                'okdiscount-product-box__list-item-container--button': hasDiscountClassButton
            });
            discountCodeItem = (
                <li className="okdiscount-product-box__list-item">
                    {codeIcon}
                    <span className={discountClassNames}>
                        <FormattedText
                            className="okdiscount-product-box__list-item-text"
                            value="OKDiscounts-discountCode"
                        />
                        {discountCodeOrButton}
                    </span>
                </li>
            )
        }

        return discountCodeItem;
    }

    buildValidityUntilItem() {
        const { immOkDiscount } = this.props;
        const validityDate = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'validityDate', 'text']);
        const validityDateUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'validityDate', 'url']);

        if (!!validityDate && !!validityDateUrl) {
            const validityDateIcon = this.buildIcon(validityDateUrl);
            let validityUntilItem;

            if (!!validityDate) {
                const validityUntilDate = dateHelper.formatDate(validityDate, DATE_FORMAT_WITH_DASHES);

                validityUntilItem = (
                    <span className="okdiscount-product-box__list-item-container">
                        <FormattedText
                            className="okdiscount-product-box__list-item-text"
                            value="OKDiscounts-validityUntil"
                        />
                        <span className="okdiscount-product-box__list-item-value">
                            {validityUntilDate}
                        </span>
                    </span>
                );
            }

            return (
                <li className="okdiscount-product-box__list-item">
                    {validityDateIcon}{validityUntilItem}
                </li>
            );
        }
    }

    buildLegalItem() {
        const { immOkDiscount } = this.props;
        const legalInformationText = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'legals', 'text']);
        const legalInformationUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'legals', 'url']);
        const legalIconUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'legals', 'icon', 'url']);
        let legalInfoItem;

        if (!!legalInformationText) {
            if (!!legalInformationUrl) {
                legalInfoItem = (
                    <OKLink
                        modifier="editorial"
                        onClick={this.handleClickLegalSection}
                        target="_blank"
                        to={legalInformationUrl}
                    >
                        {legalInformationText}
                    </OKLink>
                );
            } else {
                legalInfoItem = legalInformationText;
            }
        } else {
            if (!!legalInformationUrl) {
                legalInfoItem = (
                    <OKLink
                        modifier="emphasize"
                        onClick={this.handleClickLegalSection}
                        target="_blank"
                        to={legalInformationUrl}
                    >
                        {legalInformationUrl}
                    </OKLink>
                );
            }
        }

        if (!!legalInfoItem || !!legalIconUrl) {
            const legalIcon = this.buildIcon(legalIconUrl);
            legalInfoItem = (
                <li className="okdiscount-product-box__list-item">
                    {legalIcon}{legalInfoItem}
                </li>
            );
        }

        return legalInfoItem;
    }

    buildDiscountSteps() {
        const { immOkDiscount } = this.props;
        const discountRequirements = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'requirements']);
        const requirementsTitle = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'requirementsTitle']);
        let discountRequirementsSteps;

        if (!!discountRequirements) {
            discountRequirementsSteps = discountRequirements.map((immStep, key) => (
                <div className="okdiscount-product-box__step" key={key}>
                    <h3 className="okdiscount-product-box__step-title">
                        {immStep.get('title')}
                    </h3>
                    <HTMLSafeInjector
                        customClass="okdiscount-product-box__step-description public-cms-styles"
                        message={immStep.get('body')}
                    />
                </div>
            ));

            return (
                <div className="okdiscount-product-box__steps-section">
                    <h2 className="okdiscount-product-box__steps-section-title">
                        {requirementsTitle}
                    </h2>
                    {discountRequirementsSteps}
                </div>
            );
        }
    }

    buildDiscountInformation() {
        const discountCodeItem = this.buildDiscountCodeItem();
        const legalInfoItem = this.buildLegalItem();
        const validityUntilItem = this.buildValidityUntilItem();
        const callToAction = this.buildCallToAction("info-section-button");

        return (
            <div className="okdiscount-product-box__information-section">
                <ul className="okdiscount-product-box__list-items">
                    {discountCodeItem}
                    {validityUntilItem}
                    {legalInfoItem}
                </ul>
                {callToAction}
            </div>
        );
    }

    buildMessageDiscountProductBox() {
        return (
            <div className="okdiscount-product-box__discount-conditions" >
                <OKMessage>
                    <FormattedText value="OKDiscounts-checkHere" />
                    <span className="okdiscount-product-box__discount-conditions-link">
                        <OKLink
                            modifier="emphasize"
                            onClick={this.handleClickConditions}
                            target="_blank"
                            to={formatText('OKDiscounts-linkUrl')}
                        >
                            <FormattedText value="OKDiscounts-termsAndConditionsLinkText" />
                        </OKLink>
                    </span>
                </OKMessage>
            </div>
        );
    }

    buildHeaderDiscountProductBox() {
        const { immOkDiscount } = this.props;
        const imageUrl = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'image', 'url']) || '';
        const subTitle = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'subTitle']) || '';
        const title = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'title']) || '';
        let percentageLabel;
        const callToAction = this.buildCallToAction("header-button");
        if (!immOkDiscount.get('errorPercentage') && !!immOkDiscount.get('percentage')) {
            percentageLabel = (
                <div className="okdiscount-product-box__label-discount" style={{backgroundColor: immOkDiscount.get('percentageBackgroundColor')}}>
                    {immOkDiscount.get('percentage')} %
                </div>
            );
        }

        return (
            <div className="row">
                <div className="okdiscount-product-box__image-container col-xs-12 col-md-8">
                    <img
                        className="okdiscount-product-box__image"
                        src={imageUrl}
                    />
                    {percentageLabel}
                </div>
                <div className="okdiscount-product-box__discount-info col-xs-12 col-md-4">
                    <HTMLSafeInjector
                        customClass="okdiscount-product-box__discount-info-title public-cms-styles"
                        message={title}
                    />
                    <HTMLSafeInjector
                        customClass="okdiscount-product-box__discount-info-subtitle public-cms-styles"
                        message={subTitle}
                    />
                    {callToAction}
                </div>
            </div>
        )
    }

    navigateToNewLink() {
        const { immOkDiscount } = this.props;
        const immCallToAction = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'callToAction']);

        if (!!immCallToAction) {
            const openNewTab = immCallToAction.get('openNewTab');
            const callToActionUrl = immCallToAction.get('url') || '';
            if (openNewTab) {
                window.open(`${callToActionUrl}-${this.state.saltedHashValue}`);
            } else {
                window.open(`${callToActionUrl}-${this.state.saltedHashValue}`, "_self");
            }
        }
    }

    buildBodyDiscountProductBox() {
        const { immOkDiscount } = this.props;
        const discountRequirements = immOkDiscount.getIn(['okDiscountDetail', 'discount', 'requirements']);
        const discountInformationSection = this.buildDiscountInformation();
        const messageDiscountProductBox = this.buildMessageDiscountProductBox();
        let discountStepsSection;

        if (!!discountRequirements && discountRequirements.size > 0) {
            discountStepsSection = this.buildDiscountSteps();
        }

        return (
            <div className="okdiscount-product-box__body">
                <div className="row">
                    <div className="col-xs-12 col-md-8 okdiscount-product-box__body-message">
                        {discountStepsSection}
                        {messageDiscountProductBox}
                    </div>
                    <div className="col-xs-12 col-md-4 okdiscount-product-box__body-discount-info">
                        {discountInformationSection}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immOkDiscount } = this.props;
        let headerDiscountProductBox;
        let bodyDiscountProductBox;
        let result;

        if (immOkDiscount.getIn(['okDiscountDetail', 'discount', 'isLoading'])) {
            result = <LoadingSection />;
        } else {
            headerDiscountProductBox = this.buildHeaderDiscountProductBox();
            bodyDiscountProductBox = this.buildBodyDiscountProductBox();
            result = (
                <div className="okdiscount-product-box">
                    {headerDiscountProductBox}
                    {bodyDiscountProductBox}
                </div>
            )
        }

        return result;
    }
}

OkDiscountProductBox.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immOkDiscount: PropTypes.object.isRequired,
    requestExternalCode: PropTypes.func.isRequired,
    requestReferralPromotionDiscount: PropTypes.func.isRequired
};

module.exports = OkDiscountProductBox;
